import React from 'react';
import { useIntl } from 'umi';

import './index.scss';

const NotFound: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="dbh-not-found-page">
      <div className="dbh-not-found-page__card">
        <div className="dbh-not-found-page__code">404</div>
        <div className="dbh-not-found-page__title">
          {formatMessage({
            id: 'dbh_not_found_title',
            defaultMessage: 'Unrecognized Link',
          })}
        </div>
        <div className="dbh-not-found-page__desc">
          {formatMessage({
            id: 'dbh_not_found_desc',
            defaultMessage:
              "The system doesn't recognize the format of the link you entered. Please verify the link and try again.",
          })}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
